import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgPlayIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
    >
      <path d="M20.0002 36.6667c9.2047 0 16.6666-7.4619 16.6666-16.6667S29.2049 3.3333 20.0002 3.3333c-9.2048 0-16.6667 7.462-16.6667 16.6667 0 9.2048 7.4619 16.6667 16.6667 16.6667" />
      <path d="M15.8335 14.9422c0-.7954 0-1.1932.1662-1.4152a.834.834 0 0 1 .6078-.3318c.2766-.0198.6112.1953 1.2803.6255l7.8677 5.0577c.5806.3733.871.5599.9712.7973a.833.833 0 0 1 0 .6487c-.1002.2373-.3906.4239-.9712.7972l-7.8677 5.0578c-.6691.4301-1.0037.6452-1.2803.6254a.833.833 0 0 1-.6078-.3318c-.1662-.222-.1662-.6197-.1662-1.4152z" />
    </g>
  </svg>
);
export default SvgPlayIcon;
